import { PermissionMatrixGetters } from './partials/matrix'
import { PermissionsRoleGetters } from './partials/role'
import { ResourceGetters } from './partials/resources'
import { TeamGetters } from './partials/team'

export const PermissionGetters = {
  ...PermissionMatrixGetters,
  ...PermissionsRoleGetters,
  ...ResourceGetters,
  ...TeamGetters,
}
